const validateAgentCode = async (params, axios) => {
  const { data } = await axios.get('/validate-agent-code', {
    params,
  });

  return data;
};

export default validateAgentCode;
